<template>
  <a href="javascript: () => { return false; }"
    @click="$emit('action')"
    :target="target"
    :class="`ibutton-${color} btn btn-outline-${color} over-block`"
    v-c-tooltip.click="tooltip"
    ><i :class="`${icon}`"></i
  >
    {{label}}
  </a>
</template>
<script>
export default {
  props: {
    target: {
      type: String,
      default: () => {
        return ''
      }
    },
    icon: {
      type: String,
      default: () => {
        return 'cil-check'
      }
    },
    tooltip: {
      type: String,
      default: () => {
        return ''
      }
    },
    label: {
      type: String,
      default: () => {
        return ''
      }
    },
    color: {
      type: String,
      default: () => {
        return 'success'
      }
    }
  }
};
</script>
